import * as api from '@gitbook/api-client';
import { isPricingFeatureAvailable } from '@gitbook/app-pricing';

import { SearchButton, type SearchButtonProps } from './SearchButton';

export interface OrganizationSearchButtonProps extends Omit<SearchButtonProps, 'ai'> {
    organization: api.Organization;
}

export function OrganizationSearchButton(props: OrganizationSearchButtonProps) {
    const { organization, ...rest } = props;
    return (
        <SearchButton
            ai={isPricingFeatureAvailable(organization, {
                featureKey: api.OrganizationFeature.AiLens,
            })}
            {...rest}
        />
    );
}
